<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="loi">
<h1 class="ctfm"><a class="page" id="px"></a><a class="page" id="pxi"></a><a class="xref" href="#/Text/Hardesty0006#toc">Figures and Tables</a></h1>
<h2 class="ah" id="ahloi01">Figures</h2>
<p class="toc"><a href="#/Text/Hardesty0010#Fig1">1. “A Female Negro Slave, with a Weight chain”</a></p>
<p class="toc"><a href="#/Text/Hardesty0010#Fig2">2. “Joanna”</a></p>
<p class="toc"><a href="#/Text/Hardesty0010#Fig3">3. “A Coromantyn Free Negro, or Ranger, armed”</a></p>
<h2 class="ah" id="ahloi02">Tables</h2>
<p class="toc"><a href="#/Text/Hardesty0011#Table1">1. Boston Slave Ownership by Occupation in Probate Inventories, 1700–1775</a></p>
<p class="toc"><a href="#/Text/Hardesty0011#Table2">2. Runaway Servant Advertisements in Boston, 1700–1750</a></p>
<p class="toc"><a href="#/Text/Hardesty0012#Table3">3. Black Marriages in Boston, 1700–1775</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0007.vue?0d4d4aaa